import { Component, OnInit, OnDestroy } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { ModalController } from '@ionic/angular';
import { StaffCard } from 'src/app/admin/models/staffCard';
import { PlayroomService } from 'src/app/admin/services/playroom.service';
import { StaffcardService } from 'src/app/admin/services/staffcard.service';
import { validateStaffCard } from 'src/app/utils/formValidators';
import { environment } from 'src/environments/environment';
import * as signalR from "@microsoft/signalr";

@Component({
  selector: 'app-add-staffcard-modal',
  templateUrl: './add-staffcard-modal.component.html',
  styleUrls: ['./add-staffcard-modal.component.scss'],
})
export class AddStaffcardModalComponent implements OnInit, OnDestroy {
  staffCard: StaffCard = new StaffCard();
  errMsg = '';
  msg = '';
  checkboxes: any[];
  playrooms$ = this.roomService.playrooms$;
  connection;
  disconnectedOnPurpose = false;
  apiUrl = environment.apiUrl;
  disableButton = false;
  roomId;


  constructor(private modalController: ModalController, private roomService: PlayroomService, private staffCardService: StaffcardService, fb: FormBuilder) {

  }
  ngOnInit() {
    this.roomService.getAllPlayrooms();
    this.playrooms$.subscribe((rooms) => {
      console.log("playrooms$");
      console.log(rooms);
      this.checkboxes = rooms;
      this.checkboxes.map((x) => x.checked = false);
    });

    this.connection = new signalR.HubConnectionBuilder()
      .withUrl(this.apiUrl + 'hubs/smartCardHub')
      .build();

    this.ensureSignalRConnected();

    this.connection.on('ReceiveSmartCardId', (smartCardId: number, errorMessage: string) => {
      if (smartCardId === 0) {
        this.errMsg = errorMessage;
        return;
      }
      else {
        var hex = this.toHex(smartCardId);
        let reverseID = this.reverseNumber(hex);
        this.staffCard.codeId = reverseID.toUpperCase();
        this.msg = '';
      }
    });

    this.connection.onclose(error => {
      if (!this.disconnectedOnPurpose) {
        this.errMsg = 'Izgubljena veza sa serverom. Učitajte stranicu ponovo.';
      }
    });

    this.roomId = '1'; //roomId is hardcoded for this purpuse
  }

  toHex(num: number): string {
    const map = "0123456789abcdef";
    let hex = num === 0 ? "0" : "";
    while (num !== 0) {
      hex = map[num & 15] + hex;
      num = num >>> 4;
    }

    if (hex.length == 7) hex = "0" + hex;

    return hex;
  }

  reverseNumber(hex) {
    let hexStr = hex.toString();
    let reversedNum = "";
    while (hexStr.length !== 0) {
      reversedNum = reversedNum + hexStr.slice(-2);
      hexStr = hexStr.substring(0, hexStr.length - 2);
    }

    return reversedNum;
  }

  ngOnDestroy() {
    this.disconnectedOnPurpose = true;
    this.connection.stop().catch((err) => console.log(err));
  }

  readCard() {
    this.ensureSignalRConnected();
    this.connection.invoke('RegisterSmartCardRequest', this.roomId, 'checkin').then(result => {
      if (result) {
        this.errMsg = result;
      } else {
        this.errMsg = '';
        this.msg = 'Čeka se na očitavanje kartice...';
        this.disableButton = true;
      }
    });
  }

  addStaffCard() {

    this.staffCard.roomIds = this.checkboxes.filter((checkbox) => checkbox.checked).map((checkbox) => checkbox.id);

    const formValidation = validateStaffCard(this.staffCard);

    this.errMsg = formValidation.errMsg;
    if (formValidation.isValid) {
      this.staffCardService.addStaffCard(this.staffCard).subscribe(res => {
        this.staffCardService.getAllStaffCard({
          currentPage: 1, itemsPerPage: 100,
          enterQuery: '', fullNameQuery: '', roomNameQuery: ''
        });
        this.dismissModal();
        console.log("addStaffCard")
        console.log("this.staffCard")

      }, (err) => {
        JSON.stringify(err.error.title);
      });
    }


  }

  ensureSignalRConnected() {
    if (this.connection.state != signalR.HubConnectionState.Connected) {
      this.connection.start().catch((err) => {
        console.log(err);
        this.errMsg = 'Izgubljena veza sa serverom. Učitajte stranicu ponovo.';
      });
    }
  }

  dismissModal() {
    this.modalController.dismiss();
  }
}



